import React,{Component} from 'react';
import {Header} from '../header/Header';
import {Footer} from '../footer/Footer';

export class Faqs extends Component{
  render(){
      return(
       <>
       <Header></Header>
       <br/>
       <br/>
       <br/>
       <div className="container">
       <h1>This Page is Under Construction..</h1>

       </div>
       <br/>
       <br/>
       <br/>
       <Footer></Footer>
       </>
      )
  }

}